import './styles.scss';

import React, {CSSProperties} from 'react';

export interface TableModel {
    text: string;
    value: string;
    bigMode?: boolean;
}

interface AppTableProps {
    style?: CSSProperties;
    data: TableModel[];
}

export const AppTable = ({style, data}: AppTableProps) => {
    return (
        <div className='app-table' style={style}>
            {data.map(({text, value, bigMode = false}, index) => (
                <div className='app-table__row' key={index}>
                    <div className='app-table__cell'>{text}</div>
                    <div className='app-table__cell'>
                        <div className={`${bigMode ? 'app-table__value' : ''}`}>{value}</div>
                    </div>
                </div>
            ))}
        </div>
    );
};
